import "./Register.css";
const HommieViewCard = ({ component }) => {
  let Component = component;
  return (
        <Component></Component>
  );
};  
export default HommieViewCard;
